import React from 'react';
import { View, Text, StyleSheet, Image, TouchableOpacity } from 'react-native';
import { globalStyles } from '../styles/globalStyles';
import { BackgroundVideo } from '../components/BackgroundVideo';
import { useUser } from '../components/LoginPersistence';
import { getAuth, signOut } from 'firebase/auth';

export function WaitlistScreen({ navigation }) {
  const { user } = useUser();
  const auth = getAuth();

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      navigation.replace('Login');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <View style={globalStyles.container}>
      <BackgroundVideo />
      <View style={[globalStyles.overlay, styles.contentContainer]}>
        <View style={styles.card}>
          <Image
            source={require('../../assets/logos/logo.png')}
            style={styles.logo}
          />
          <Text style={styles.welcomeTitle}>Welcome to Venue Report Card!</Text>
          <Text style={styles.userName}>{user?.firstName} {user?.lastName}</Text>
          
          <Text style={styles.message}>
            Thank you for registering! We're currently in closed alpha testing.
          </Text>
          
          <Text style={styles.details}>
            Your account has been added to our waitlist. Once approved, you'll have full access to:
          </Text>
          
          <View style={styles.featuresList}>
            <Text style={styles.feature}>• Submit and view venue reports</Text>
            <Text style={styles.feature}>• Connect with other industry professionals</Text>
            <Text style={styles.feature}>• Access detailed venue information</Text>
            <Text style={styles.feature}>• Contribute to our growing community</Text>
          </View>
          
          <Text style={styles.waitMessage}>
            We'll notify you via email when your account is activated.
          </Text>

          <TouchableOpacity
            style={styles.signOutButton}
            onPress={handleSignOut}
          >
            <Text style={styles.signOutText}>Sign Out</Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  contentContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  card: {
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    borderRadius: 15,
    padding: 30,
    width: '100%',
    maxWidth: 600,
    alignItems: 'center',
    backdropFilter: 'blur(10px)',
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.1)',
  },
  logo: {
    width: 120,
    height: 120,
    marginBottom: 20,
    resizeMode: 'contain',
  },
  welcomeTitle: {
    fontSize: 28,
    color: '#ffffff',
    fontFamily: 'VastagoGrotesk',
    marginBottom: 10,
    textAlign: 'center',
  },
  userName: {
    fontSize: 24,
    color: '#0bb5df',
    fontFamily: 'VastagoGrotesk',
    marginBottom: 20,
    textAlign: 'center',
  },
  message: {
    fontSize: 18,
    color: '#ffffff',
    fontFamily: 'VastagoGrotesk',
    marginBottom: 20,
    textAlign: 'center',
    lineHeight: 24,
  },
  details: {
    fontSize: 16,
    color: '#ffffff',
    fontFamily: 'VastagoGrotesk',
    marginBottom: 15,
    textAlign: 'center',
  },
  featuresList: {
    alignSelf: 'stretch',
    marginBottom: 20,
    paddingHorizontal: 20,
  },
  feature: {
    fontSize: 16,
    color: '#ffffff',
    fontFamily: 'VastagoGrotesk',
    marginBottom: 10,
    paddingLeft: 10,
  },
  waitMessage: {
    fontSize: 16,
    color: '#0bb5df',
    fontFamily: 'VastagoGrotesk',
    marginBottom: 30,
    textAlign: 'center',
  },
  signOutButton: {
    backgroundColor: 'rgba(231, 76, 60, 0.8)',
    paddingVertical: 12,
    paddingHorizontal: 30,
    borderRadius: 8,
    marginTop: 10,
  },
  signOutText: {
    color: '#ffffff',
    fontSize: 16,
      fontFamily: 'VastagoGrotesk',
  },
}); 